import {
  DownOutlined,
  FilePdfOutlined,
  FileWordOutlined,
} from '@ant-design/icons'
import { Button, Dropdown, Menu, Tooltip } from 'antd'
import PropTypes from 'prop-types'

import { createUseStyles } from 'react-jss'
import DownloadLink from './DownloadLink'

const PDF_PENDING_TOOLTIP =
  'Signatures are being applied — report will be ready shortly'

const useStyles = createUseStyles({
  icon: {
    marginRight: 10,
  },
  pendingItem: {
    color: 'rgba(0, 0, 0, 0.25)',
    cursor: 'not-allowed',
    display: 'inline-flex',
    alignItems: 'center',
  },
})

export default function DownloadButtons({ resource, pdfPending = false }) {
  const classes = useStyles()
  const { filePath, rawFilePath, mergedFilePath } = resource
  const { deviceReport, biobridgeReport, mergedReport } = resource

  const biobridgeReportLink = biobridgeReport || filePath
  const deviceReportLink = deviceReport || rawFilePath
  const mergedReportLink = mergedFilePath || mergedReport

  const downloadLinks =
    biobridgeReportLink || deviceReportLink || mergedReportLink

  if (!downloadLinks) return null

  return (
    <Dropdown
      overlay={
        <Menu>
          {biobridgeReportLink && (
            <Menu.Item key="1" disabled={pdfPending}>
              {pdfPending ? (
                <Tooltip title={PDF_PENDING_TOOLTIP}>
                  <span className={classes.pendingItem}>
                    <FilePdfOutlined className={classes.icon} />
                    <span>Report PDF</span>
                  </span>
                </Tooltip>
              ) : (
                <DownloadLink path={biobridgeReportLink}>
                  <FilePdfOutlined className={classes.icon} />
                  <span>Report PDF</span>
                </DownloadLink>
              )}
            </Menu.Item>
          )}
          {deviceReportLink && (
            <Menu.Item key="2">
              <DownloadLink path={deviceReportLink}>
                <FileWordOutlined className={classes.icon} />
                <span>Transmission PDF</span>
              </DownloadLink>
            </Menu.Item>
          )}
          {mergedReportLink && (
            <Menu.Item key="3" disabled={pdfPending}>
              {pdfPending ? (
                <Tooltip title={PDF_PENDING_TOOLTIP}>
                  <span className={classes.pendingItem}>
                    <FileWordOutlined className={classes.icon} />
                    <span>Merged PDF</span>
                  </span>
                </Tooltip>
              ) : (
                <DownloadLink path={mergedReportLink}>
                  <FileWordOutlined className={classes.icon} />
                  <span>Merged PDF</span>
                </DownloadLink>
              )}
            </Menu.Item>
          )}
        </Menu>
      }
    >
      <Button>
        Download <DownOutlined />
      </Button>
    </Dropdown>
  )
}

DownloadButtons.propTypes = {
  resource: PropTypes.shape({
    editableFilePath: PropTypes.string,
    filePath: PropTypes.string,
    rawFilePath: PropTypes.string,
    mergedFilePath: PropTypes.string,
    deviceReportPath: PropTypes.string,
    deviceReport: PropTypes.string,
    biobridgeReport: PropTypes.string,
    mergedReport: PropTypes.string,
  }).isRequired,
  pdfPending: PropTypes.bool,
}
